
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { FARHistoryIcon } from "../../../assets/images";
import { formateDateTime } from "../../../utils/commonFunctions";
import { CircularAvatar, TableLoader } from "../../commons";

type AppProps = {
  storeHistoryData?: any;
  showHistoryModal: boolean;
  fetching: boolean;
  fixedAssetHistoryData: any;
  handleHistoryModal: () => void;
  auditHistoryData: {
    finacAssetId: string;
    description: string;
  };
};
const FixedAssetHistory = ({
  storeHistoryData,
  showHistoryModal,
  fetching,
  fixedAssetHistoryData,
  auditHistoryData,
  handleHistoryModal,
}: AppProps) => {
  const styleColor = (name: string) => {
    return {
      marginTop: "4px",
      padding: "4px 12px",
      color: `${
        name === "Good"
          ? "#82b01f"
          : name === "Obsolete"
          ? "#dd4433"
          : name === "Missing"
          ? "#262a44"
          : name === "Bad"
          ? "#f3a119"
          : name === "Yet to Capitalize"
          ? "rgb(32, 128, 246)"
          : ""
      }`,
      background: `${
        name === "Good"
          ? "#e7f0d4"
          : name === "Obsolete"
          ? "#ffebe9"
          : name === "Missing"
          ? "#f4f6f8"
          : name === "Bad"
          ? "#faedd8"
          : name === "Yet to Capitalize"
          ? "rgb(227, 239, 255)"
          : ""
      }`,
      borderRadius: "16px",
    };
  };

  const blank = () => {
    return {};
  };

  return (
    <div>
      <Modal
        isOpen={showHistoryModal}
        toggle={handleHistoryModal}
        backdrop="static"
      >
        <ModalHeader id="cross-cut pb-2" toggle={handleHistoryModal}>
          <div className="">
            <img src={FARHistoryIcon} alt="history icon" className="mr-2" />
            <span style={{ fontWeight: "600", color: "#262a44" }}>
              Audit History
            </span>
          </div>
        </ModalHeader>
        <ModalBody size="lg">
          <div className="pb-2">
            <div className="ml-4 pb-3 d-flex flex-column">
              <div className="d-flex flex-column">
                <span style={{ color: "#6e7491", fontSize: "14px" }}>
                  Finac Asset ID
                </span>
                <span style={{ color: "#262a44", fontSize: "15px" }}>
                  {auditHistoryData?.finacAssetId}
                </span>
              </div>
              <div className="d-flex flex-column">
                <span style={{ color: "#6e7491", fontSize: "14px" }}>
                  Description
                </span>
                <span style={{ color: "#262a44", fontSize: "15px" }}>
                  {auditHistoryData?.description}
                </span>
              </div>
            </div>
            <div
              className={`ml-2 ${
                fixedAssetHistoryData?.length === 0
                  ? "d-flex justify-content-around align-items-center"
                  : ""
              }`}
              style={{ height: "350px", overflowY: "auto" }}
            >
              {fixedAssetHistoryData?.length > 0 ? (
                <div className="new-table-style table-responsive pr-2 pl-2 pb-2">
                  <table className="table table-bordered thead-light">
                    <thead className="text-start sticky-table-header">
                      <tr>
                        <th>LAST VERIFY BY</th>
                        <th>LAST VERIFY AT</th>
                        <th>CONDITION</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fixedAssetHistoryData?.length > 0
                        ? fixedAssetHistoryData?.map(
                            (item: any, index: number) => {
                              return (
                                <tr>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <span className="mr-2">
                                        <CircularAvatar
                                          image={
                                            item?.verify_by_details[0]
                                              ?.profile_pic
                                          }
                                          name={`${
                                            item?.verify_by_details[0]
                                              ?.first_name
                                          } ${
                                            item?.verify_by_details[0]
                                              ?.last_name
                                              ? item?.verify_by_details[0]
                                                  ?.last_name
                                              : ""
                                          }`}
                                        />
                                      </span>
                                      <span>
                                        {item?.verify_by_details[0]?.first_name}{" "}
                                        {item?.verify_by_details[0]?.last_name
                                          ? item?.verify_by_details[0]
                                              ?.last_name
                                          : ""}
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <span
                                      style={{
                                        color: "#6e7491",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {formateDateTime(item?.verify_at)}
                                    </span>
                                  </td>
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <span
                                      style={
                                        item?.condition
                                          ? styleColor(item?.condition)
                                          : blank()
                                      }
                                    >
                                      {item?.condition ? item?.condition : "NA"}
                                    </span>
                                  </td>
                                </tr>
                              );
                            }
                          )
                        : ""}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div
                  className="mb-2"
                  style={{
                    color: "#262a44",
                    fontSize: "18px",
                    textAlign: "center",
                    fontWeight: "500",
                  }}
                >
                  No Audit History Yet!
                </div>
              )}
            </div>
            {fetching && <TableLoader Rows={8} ColumnPerRow={2} />}
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default FixedAssetHistory;
